/**
 * @author Noovle.srl
 */
import OnTheMap from "./classes/onthemap";

export default { OnTheMap };

window["noovle"] = {};
window["noovle"]["onthemap"] = OnTheMap;
